
      export interface IntrospectionResultData {
        __schema: {
          types: {
            kind: string;
            name: string;
            possibleTypes: {
              name: string;
            }[];
          }[];
        };
      }

      const result: IntrospectionResultData = {
  "__schema": {
    "types": [
      {
        "kind": "UNION",
        "name": "GuestData",
        "possibleTypes": [
          {
            "name": "GuestPublic"
          },
          {
            "name": "GuestShort"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "NotificationBody",
        "possibleTypes": [
          {
            "name": "EventComponentAddedBody"
          },
          {
            "name": "NoneBody"
          },
          {
            "name": "RsvpBody"
          },
          {
            "name": "SimpleNotificationBody"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "Offering",
        "possibleTypes": [
          {
            "name": "PackageOffering"
          },
          {
            "name": "RoomOffering"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "User",
        "possibleTypes": [
          {
            "name": "Admin"
          },
          {
            "name": "Concierge"
          },
          {
            "name": "Customer"
          },
          {
            "name": "Guest"
          },
          {
            "name": "UserProfile"
          },
          {
            "name": "Vendor"
          }
        ]
      }
    ]
  }
};

      export default result;
    